import { useState, useEffect } from 'react';
import { getOffer } from './api';

/**
 * Founding-member launch offer state (public, unauthenticated).
 *
 * Returns null until loaded AND whenever the offer is inactive, so callers can
 * treat any falsy value as "no offer -> show standard pricing". When the launch
 * window is open it returns { active, ends_at, founding_prices }.
 */
export default function useFoundingOffer() {
  const [offer, setOffer] = useState(null);
  useEffect(() => {
    let alive = true;
    getOffer()
      .then(o => { if (alive && o && o.active) setOffer(o); })
      .catch(() => {});
    return () => { alive = false; };
  }, []);
  return offer;
}
